import { Suspense } from "react";
import { Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { KYCUserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/KYCUserGroupMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { Permissions } from "../../../util/Permissions";
import { CorporateAccountsManagement } from "./CorporateAccounts";

const CorporateAccountsPages = () => {
    return (
        <>
            <AsideMenu>
                <KYCUserGroupMenu destination="/corporate-accounts" showCounts={false} />
            </AsideMenu>
            <Section>
                <Suspense fallback={<LayoutSplashScreen />}>
                    <Switch>
                        <ContentRoute
                            path="/corporate-accounts/:userGroup/:statusTab?"
                            permission={Permissions.PENDING_KYC}
                            component={CorporateAccountsManagement}
                        />
                    </Switch>
                </Suspense>
            </Section>
        </>
    );
};

export default CorporateAccountsPages;
